import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import TooltipedImg from '../Common/TooltipedImg';
import arrowTop from '../../images/arrow_top.png';
import arrowUp from '../../images/arrow_up.png';
import arrowDown from '../../images/arrow_down.png';
import arrowBottom from '../../images/arrow_bottom.png';

import {
    moveToVisibleEnd,
    moveToTop,
    moveDown,
    moveUp,
    isMoveUpDisabled,
    isMoveDownDisabled
} from '../../_legacy/Screens/Common/actions/Collection';
import {textConst, getLocalizedText, texts} from '../../constants/TextConst';

@observer
class Movements extends Component<any, any> {
    constructor(props) {
        super(props);
        this.moveFieldToBottom = this.moveFieldToBottom.bind(this);
        this.moveFieldToTop = this.moveFieldToTop.bind(this);
        this.moveFieldDown = this.moveFieldDown.bind(this);
        this.moveFieldUp = this.moveFieldUp.bind(this);
    }

    moveFieldToTop() {
        const {field} = this.props;

        if (!isMoveUpDisabled(field)) {
            moveToTop(field);
        }
    }

    moveFieldUp() {
        const {field} = this.props;
        if (!isMoveUpDisabled(field)) {
            moveUp(field);
        }
    }

    moveFieldToBottom() {
        const {field} = this.props;
        if (!isMoveDownDisabled(field)) {
            moveToVisibleEnd(field);
        }
    }

    moveFieldDown() {
        const {field} = this.props;
        if (!isMoveDownDisabled(field)) {
            moveDown(field);
        }
    }

    render() {
        const {field} = this.props;

        // TODO: check that we don't need showMovement covers all cases
        // let showMovements = false;
        // if (panelType  === panelTypes.REPORT ) {
        // 	showMovements = selectedField && (!isMoveUpDisabled(field) || !isMoveDownDisabled(field));
        // }

        return (
            <div className={`actions`}>
                <div
                    className={`movement ${isMoveUpDisabled(field) && 'disabled'}`}
                    onClick={this.moveFieldToTop}
                >
                    <TooltipedImg
                        src={arrowTop}
                        alt={textConst.moveTopAlt}
                        tooltipText={getLocalizedText(texts.moveToTopTooltip)}
                    />
                </div>
                <div
                    className={`movement ${isMoveUpDisabled(field) && 'disabled'}`}
                    onClick={this.moveFieldUp}
                >
                    <TooltipedImg
                        src={arrowUp}
                        alt={textConst.moveUpAlt}
                        tooltipText={getLocalizedText(texts.moveUpTooltip)}
                    />
                </div>
                <div
                    className={`movement ${isMoveDownDisabled(field) && 'disabled'}`}
                    onClick={this.moveFieldDown}
                >
                    <TooltipedImg
                        src={arrowDown}
                        alt={textConst.moveDownAlt}
                        tooltipText={getLocalizedText(texts.moveDownTooltip)}
                    />
                </div>
                <div
                    className={`movement ${isMoveDownDisabled(field) && 'disabled'}`}
                    onClick={this.moveFieldToBottom}
                >
                    <TooltipedImg
                        src={arrowBottom}
                        alt={textConst.moveToBottomAlt}
                        tooltipText={getLocalizedText(texts.moveToBottomTooltip)}
                    />
                </div>
            </div>
        );
    }
}

export default Movements;
